import { Box, Typography } from "@mui/material";
import QRGenerator from "./qrGenerator";

const PDFGenerator = (props) => {
  const { url, part, location } = props;

  const calculateFontSize = (text) => {
    const baseFontSize = 16;
    const scaleFactor = 0.3;
    const textLength = text.length;
    var fontSize;
    if (textLength * scaleFactor > baseFontSize) {
      fontSize = 9.5;
    } else {
      fontSize = baseFontSize * 1.3 - (textLength * scaleFactor) / 1.5;
    }

    return fontSize;
  };

  const partFontSize = calculateFontSize(part);

  const styles = {
    view: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      borderBottom: "1pt solid #000",
      top: 0,
    },
    subView: {
      justifyContent: "center",
      textAlign: "center",
      marginLeft: -7,
      width: "100%",
      height: "100%",
    },
    partText: {
      fontSize: props.location === "" ? "25px" : `${partFontSize}px`,
      color: "black",
      transformOrigin: "top left",
    },
    locText: {
      fontSize: "10px",
      color: "black",
    },
  };

  return (
    <div style={styles.view}>
      <Box
        sx={{
          justifyContent: "center",
          textAlign: "center",
          px: 1,
          "& canvas": {
            width: "100%",
            maxWidth: "67px !important",
            minWidth: "67px !important",
          },
        }}
      >
        <QRGenerator width={1920} url={url} />
      </Box>
      <div style={styles.subView}>
        <Typography style={styles.partText}>{part}</Typography>
        <div>
          <div style={styles.locText}>{location}</div>
        </div>
      </div>
    </div>
  );
};

export default PDFGenerator;
